<div class="flex flex-col w-full p-8">
    <!-- Header -->
    <div class="flex items-center justify-between">
        <div class="text-3xl font-bold tracking-tight">i18n AI Translator</div>
        <button
            mat-stroked-button
            color="warn"
            (click)="startOver()"
            *ngIf="currentStep > wizardStepEnum.Configuration"
        >
            Start Over
        </button>
    </div>

    <!-- Wizard Steps Container -->
    <div class="mt-8" [ngSwitch]="currentStep">
        <!-- Step 1: Configuration -->
        <div *ngSwitchCase="wizardStepEnum.Configuration">
            <div *ngSwitchCase="wizardStepEnum.Configuration">
                <app-step-one-config (completed)="goToStep(wizardStepEnum.FileUpload)"></app-step-one-config>
            </div>
        </div>

        <!-- Step 2: File Upload -->
        <div *ngSwitchCase="wizardStepEnum.FileUpload">
            <app-step-two-files
                (completed)="goToStep(wizardStepEnum.Processing)"
                (back)="goToStep(wizardStepEnum.Configuration)">
            </app-step-two-files>
        </div>

        <!-- Step 3: Processing -->
        <div *ngSwitchCase="wizardStepEnum.Processing">
            <app-step-three-process
                (completed)="goToStep(wizardStepEnum.Review)"
                (error)="goToStep(wizardStepEnum.FileUpload)">
            </app-step-three-process>
        </div>

        <!-- Step 4: Review -->
        <div *ngSwitchCase="wizardStepEnum.Review">
            <app-step-four-review (startOver)="startOver()"></app-step-four-review>
        </div>
    </div>
</div>
